<div class="container text-left">
  <mat-toolbar class="titulo">Cadastrar Ordem</mat-toolbar>
  <div class="container">
    <h3 class="subtitulo">Selecione o tipo da ordem</h3>
    <mat-tab-group #tabGroup dynamicHeight>
      <mat-tab label="Incluir Dívida" [attr.data-cy]="'tab-incluir-divida'">
        <app-inclusao-acao [tokenIam]="tokenIam"></app-inclusao-acao>
      </mat-tab>
      <mat-tab label="Baixar Dívida" [attr.data-cy]="'tab-baixar-divida'">
        <app-baixa-anotacao [tokenIam]="tokenIam" [ordemBaixaInput]="ordem"></app-baixa-anotacao>
      </mat-tab>
      <mat-tab label="Reincluir Dívida" [attr.data-cy]="'tab-reincluir-divida'">
        <app-revogacao-ordem [tokenIam]="tokenIam" (openBaixaTab)="selectTab(1, $event)"></app-revogacao-ordem>
      </mat-tab>
      <mat-tab label="Consultar Endereço" [attr.data-cy]="'tab-consultar-endereco'">
        <app-consultar-endereco [tokenIam]="tokenIam"></app-consultar-endereco>
      </mat-tab>
      <mat-tab label="Consultar Histórico" [attr.data-cy]="'tab-consultar-historico'">
        <app-consulta-historico [tokenIam]="tokenIam"></app-consulta-historico>
      </mat-tab>
    </mat-tab-group>

    <br />
    <br />
    <tr></tr>
    <mat-divider></mat-divider>
    <div class="btn-outros" >
      <a mat-button (click)="handleOutrasSolicitacoes()" [attr.data-cy]="'link-outras-solicitacoes'">Outras Solicitações</a>
    </div>
  </div>
</div>
